(() => {
  if (customElements.get('ni-product-assist')) return;
  class NIProductAssist extends HTMLElement {
    connectedCallback() {
      try {
        this.map = JSON.parse(this.querySelector('[data-ni-pack-map]')?.textContent || '{}');
      } catch (_) { this.map = {}; }
      this.stockMap = JSON.parse(this.querySelector('[data-ni-stock-map]')?.textContent || '{}');
      this.update(this.dataset.variantId);
      try {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const id = event?.data?.variant?.id;
          if (id && Object.prototype.hasOwnProperty.call(this.map, String(id))) this.update(String(id));
        });
      } catch (_) {}
    }
    disconnectedCallback() { if (typeof this.unsubscribe === 'function') this.unsubscribe(); }
    update(id) {
      const stockText = this.stockMap?.[String(id)];
      const stockRow = this.querySelector('[data-ni-stock-row]');
      const contact = this.querySelector('[data-ni-stock-contact]');
      if (stockRow) { stockRow.textContent = stockText || ''; stockRow.hidden = !stockText; }
      if (contact) contact.hidden = !stockText;
      const qty = this.map?.[String(id)];
      const row = this.querySelector('[data-ni-pack-row]');
      const value = this.querySelector('[data-ni-pack-qty]');
      if (!row || !value) return;
      if (qty === null || qty === undefined || qty === '') { row.classList.add('is-hidden'); value.textContent=''; return; }
      value.textContent=String(qty); row.classList.remove('is-hidden');
    }
  }
  customElements.define('ni-product-assist', NIProductAssist);
})();
